import { scrollToFirstUserInputError } from '@src-common/view/adapters/UserInputError';

const scrollToFirstError = () =>
  setTimeout(() => {
    scrollToFirstUserInputError({ block: 'center', behavior: 'smooth' });
  });

export { scrollToFirstError };
